<template>
    <div class="container">
            <div class="row py-5">
              <div class="col-md-12">
                <h1 class="primary-color mb-4 text-center">
                  Termos e Condições de Uso do Usuário
                </h1>
              </div>
              <div class="col-md-8 mx-auto">
                <div class="font-weight-light texto-cinza texto-privacidade">
                  Estes Termos e Condições de Uso (“Termos de Uso”) regulam o
                  acesso e utilização dos serviços prestados através da
                  Plataforma da Filoo Licenciamento De Software S.A., sociedade
                  anônima devidamente inscrita no CNPJ/MF sob o nº
                  13.509.469/0001-00, com sede na Rua Ferreira de Araújo, nº
                  221, cjs. 94 e 95, Pinheiros, na Cidade de São Paulo e Estado
                  de São Paulo, CEP: 05428-000 (“Filóo”), disponibilizados
                  através do site www.filoo.com.br (“Site”) e aplicações de
                  internet (“Aplicativo”), em conjunto denominados a “Plataforma
                  Filóo ”. Ao utilizar os serviços da Filóo o Usuário aceita e
                  concorda com os Termos de Uso e Política de Privacidade que
                  são indispensáveis para a utilização dos serviços disponíveis
                  na Plataforma Filóo. A Filóo poderá realizar alterações neste
                  documento sendo que as novas condições só poderão ser
                  consideradas válidas após a publicação da versão atualizada
                  destes Termos de Uso. O uso continuado dos Serviços implicará
                  na aceitação do Usuário das novas condições.
                  <hr />
                  <h3><strong>1&nbsp; &nbsp; Disposições Gerais</strong></h3>
                  <p style="padding-left: 40px;">
                    1.1 &nbsp; &nbsp; &nbsp; A Filóo é detentora de uma
                    plataforma tecnológica (“Plataforma Filóo”) que possibilita
                    ao Usuário previamente cadastrado: (i) localizar e agendar
                    consultas presenciais ou por teleconsulta com profissionais
                    de saúde autônomos e independentes da Filóo (“Prestador de
                    Serviços de Saúde”); (ii) solicitar exames com fornecedores
                    autônomos e independentes com desconto (“Parceiros”); (iii)
                    realizar busca de estabelecimentos que oferecem medicamentos
                    com descontos; (vi) se beneficiar de ações de prevenções de
                    saúde presenciais e/ou via canais digitais; e (v) ter acesso
                    a produtos e serviços acessórios de saúde ou não, sendo
                    todos os serviços (“Serviços”) disponibilizados via
                    aplicativo (“Aplicativo”) ou&nbsp; website (“Site”). Nos
                    casos dos itens “i”, “ii”, “iii” e “v”, a Filóo atua apenas
                    como intermediadora entre o Prestador de Serviços de Saúde e
                    Parceiros e os Usuários.
                  </p>
                  <p style="padding-left: 40px;">
                    1.2 &nbsp; &nbsp; &nbsp; A Filóo oferece, também, serviços
                    de atendimento de profissionais de enfermagem para auxílio
                    no pré e pós consulta, prestados diretamente por
                    profissionais da Filóo e/ou de empresas parceiras (“Serviços
                    de Enfermagem”).
                  </p>
                  <p style="padding-left: 40px;">
                    1.3 &nbsp; &nbsp; &nbsp; A Plataforma Filóo oferece ao
                    Usuário a integração e intermediação de Serviços de Saúde
                    previamente agendados (consultas presenciais e por
                    teleconsulta) e o atendimento de profissionais de enfermagem
                    para auxiliar o Usuário, sempre voltado ao atendimento
                    básico de saúde e não deve ser utilizada em casos de
                    urgência, emergência e/ou alta complexidade (tais como
                    cirurgias, tratamento de câncer, internações hospitalares
                    etc). Nesses casos, o Usuário deverá procurar a unidade de
                    atendimento de saúde mais próxima de sua localidade e/ou
                    discar 192.
                  </p>
                  <p style="padding-left: 40px;">
                    1.4 &nbsp; &nbsp; &nbsp; O atendimento de saúde online
                    (teleconsulta) é equiparado a qualquer outra relação
                    profissional com um médico ou outro profissional de saúde, e
                    por este motivo pedimos muita atenção com o compromisso do
                    Usuário em comparecer nas sessões agendadas.
                  </p>
                  <p style="padding-left: 40px;">
                    1.5 &nbsp; &nbsp; &nbsp; Sendo aceitos os termos do presente
                    Termos de Uso, a Filóo concede ao Usuário direito e a
                    licença nos termos da Cláusula 3. É vedado Uso da Plataforma
                    Filóo para outros fins.
                  </p>
                  <h3>
                    <strong>2&nbsp; &nbsp; Disponibilidade da Plataforma Filóo</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    2.1 &nbsp; &nbsp; &nbsp; A Filóo envidará todos seus
                    esforços para que a Plataforma Filóo esteja sempre
                    disponível, porém o Usuário entende que poderá haver erros
                    uma vez que depende de produtos ou serviços de terceiros
                    tais como <em>smartphones</em> e provedores de serviços de
                    internet, ou nas hipóteses de motivos externos, caso
                    fortuito ou força maior, isentando a Filóo de
                    responsabilidade por eventuais danos que decorram de
                    interrupções programadas ou imprevistas no funcionamento.
                  </p>
                  <p style="padding-left: 40px;">
                    2.2 &nbsp; &nbsp; &nbsp; O Usuário não deverá usar,
                    carregar, transmitir ou enviar de ou para o Aplicativo
                    qualquer conteúdo que viole a boa-fé, a lei, ou que possam
                    causar danos à Filóo ou a terceiros. A Filóo poderá excluir
                    tais conteúdos e responsabilizar o Usuário por eles.
                  </p>
                  <p style="padding-left: 40px;">
                    2.3 &nbsp; &nbsp; &nbsp; Para utilizar os Serviços da Filóo,
                    o Usuário precisará de um dispositivo ou computador que
                    tenha conexão com a internet. A aquisição destes produtos e
                    serviços é de sua inteira responsabilidade.
                  </p>
                  <p style="padding-left: 40px;">
                    2.4 &nbsp; &nbsp; &nbsp; A Plataforma Filóo é direcionada
                    exclusivamente para o uso e manuseio de maiores de 18 anos.
                    Menores de idade deverão ter o cadastro preenchido pelos
                    pais ou responsáveis legais com a devida apresentação de
                    documentos comprobatórios.
                  </p>
                  <h3>
                    <strong>3&nbsp; &nbsp; Condições para o uso e acesso dos serviços</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    3.1 &nbsp; &nbsp; &nbsp; Para utilizar a Plataforma Filóo, o
                    Usuário deverá ter mais de 18 (dezoito) anos e preencher o
                    cadastro com seus dados pessoais válidos, exatos e
                    verdadeiros para a criação de sua conta de usuário (a
                    “Conta”). O Usuário deverá manter seus dados sempre
                    atualizados.
                  </p>
                  <p style="padding-left: 40px;">
                    3.2 &nbsp; &nbsp; &nbsp; O Usuário será o único responsável
                    pelas informações fornecidas e o sigilo da sua senha de
                    acesso, sendo vedado o compartilhamento com terceiros,
                    assumindo toda a responsabilidade pelo seu mau uso. Toda e
                    qualquer operação realizada com seu login e senha, ainda que
                    sem sua autorização, será de sua responsabilidade exclusiva.
                  </p>
                  <p style="padding-left: 40px;">
                    3.3 &nbsp; &nbsp; &nbsp; O Usuário deverá comunicar
                    imediatamente à Filóo qualquer evento de perda, roubo, furto
                    ou extravio de seu aparelho celular, login e/ou senha de
                    acesso à Plataforma Filóo, bem como mudança na sua linha
                    telefônica. A Filóo não se responsabilizará por eventuais
                    transações indevidas realizadas antes da efetiva comunicação
                    aqui mencionada e confirmação, pela Filóo, do recebimento da
                    comunicação.
                  </p>
                  <p style="padding-left: 40px;">
                    3.4 &nbsp; &nbsp; &nbsp; Menores de idade poderão ser
                    beneficiados com os serviços da Plataforma Filóo desde que
                    seus pais ou responsáveis legais, cientes de que o
                    atendimento será realizado por um médico ou outro
                    profissional da saúde devidamente habilitado, e com a devida
                    comprovação de vínculo e responsabilidade pelo menor,
                    realizem o cadastro dos menores de idade, cabendo-lhes a
                    eles a responsabilidade pelos dados ali inseridos
                  </p>
                  <p style="padding-left: 80px;">
                    3.4.1 &nbsp; &nbsp; &nbsp; Os cadastros dos menores de idade
                    estarão obrigatoriamente vinculados ao cadastro dos pais ou
                    responsáveis legais e a aprovação do cadastro está
                    condicionada à aprovação dos documentos comprobatórios que
                    serão validados pela equipe da Filóo.
                  </p>
                  <p style="padding-left: 80px;">
                    3.4.2 &nbsp; &nbsp; &nbsp; É de responsabilidade dos pais ou
                    responsáveis legais o pagamento do plano adquirido para o
                    menor, já que vinculado ao seu cadastro.
                  </p>
                  <p style="padding-left: 40px;">
                    3.5 &nbsp; &nbsp; &nbsp; O Usuário receberá um cartão físico
                    ou virtual para utilização exclusiva na Plataforma Filóo,
                    para ser carregado com créditos pelo Usuário ou por
                    terceiros para uso dos Serviços da Plataforma Filóo
                    (“Cartão-Filóo”).
                  </p>
                  <p style="padding-left: 40px;">
                    3.6 &nbsp; &nbsp; &nbsp; O Usuário autoriza a Filóo a
                    contatá-lo ou notificá-lo sobre consultas e outros serviços
                    por quaisquer meios físicos e/ou eletrônicos, podendo
                    revogar tal autorização mediante envio de e-mail para
                    <a href="mailto:contato@filoo.com.br">contato@filoo.com.br</a>.
                  </p>
                  <p style="padding-left: 40px;">
                    3.7 &nbsp; &nbsp; &nbsp; O Usuário autoriza os Prestadores
                    de Serviços de Saúde e os profissionais de serviços de
                    enfermagem que o atenderão a terem acesso, por meio de login
                    e senha próprios, às cópias de atendimentos e/ou
                    receituários e histórico de atendimento na Plataforma Filóo
                    para tutela de sua saúde e melhor prestação dos serviços.
                  </p>
                  <p style="padding-left: 80px;">
                    3.7.1 &nbsp; &nbsp; &nbsp; A Filóo reconhece a importância
                    da preservação da privacidade dos Usuários, dos dados
                    pessoais e dados pessoais sensíveis e o sigilo médico.
                    Maiores informações sobre armazenamento, conservação e
                    compartilhamento de informações de Usuários pela Filóo podem
                    ser encontradas consultando-se a Política de Privacidade ou
                    contatando-se diretamente a Filóo, através da seção
                    “Contato”.
                  </p>
                  <p style="padding-left: 40px;">
                    3.8 &nbsp; &nbsp; &nbsp; O Usuário tem ciência que a base de
                    Prestadores de Serviços de Saúde está geolocalizada na
                    região metropolitana das cidades de São Paulo, Campo Grande
                    e Campinas.
                  </p>
                  <p style="padding-left: 40px;">
                    3.9 &nbsp; &nbsp; &nbsp; Especificamente para Teleconsulta,
                    o usuário declara estar ciente de que, após a consulta
                    online, o profissional médico poderá́ indicar a necessidade
                    de atendimento presencial ou o encaminhamento emergencial a
                    uma unidade de saúde ou pronto atendimento. O Usuário está
                    ciente de que não lhe desobriga do pagamento da Teleconsulta
                    realizada pelo profissional.
                  </p>
                  <p style="padding-left: 40px;">
                    3.10&nbsp; &nbsp; &nbsp; Para utilização dos seguros por
                    Morte Acidental, Invalidez Permanente, Auxílio Funeral e
                    Sorteio Mensal só serão válidos cadastros com usuários na
                    faixa etária de 16 a 69 anos.
                  </p>
                  <h3>
                    <strong>4&nbsp; &nbsp; Serviços de Enfermagem</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    4.1 &nbsp; &nbsp; &nbsp; Ao agendar uma consulta com um
                    Prestador de Serviços de Saúde, um consultor da Filóo poderá
                    entrar em contato com o Usuário através de uma plataforma
                    multicanal, para prestar informações antes da consulta. Esse
                    profissional não é autorizado a praticar atos privativos dos
                    Prestadores de Serviços de Saúde, como fornecer diagnóstico
                    ou prescrever medicamentos.
                  </p>
                  <p style="padding-left: 40px;">
                    4.2 &nbsp; &nbsp; &nbsp; Após realizada a consulta, ou antes
                    dela, o profissional de enfermagem da Filóo poderá entrar em
                    contato com o Usuário e esclarecer eventuais dúvidas sobre
                    exames e medicamentos prescritos pelo Prestador de Serviços
                    de Saúde, assim como dar orientação sobre preparo de exames,
                    aquisição de medicamentos com descontos ou gratuitamente na
                    rede pública. Caso seja necessária uma consulta de retorno,
                    o Usuário poderá agendar diretamente na Plataforma Filóo ou
                    mediante o auxílio de um profissional da Filóo.
                  </p>

                  <h3><strong>5&nbsp; &nbsp; Morte Acidental</strong></h3>
                  <p style="padding-left: 40px;">
                    5.1 &nbsp; &nbsp; &nbsp; Consulte as Condições Gerais dessa cobertura em
                    <a href="https://filoo.com.br/docs/Condicoes-Especiais-Cobertura-Morte.pdf"
                      target="_blank" rel="noopener noreferrer" >
                      filoo.com.br/docs/Condicoes-Especiais-Cobertura-Morte.pdf
                    </a>
                  </p>
                  <h3><strong>6&nbsp; &nbsp; Invalidez Permanente</strong></h3>
                  <p style="padding-left: 40px;">
                    6.1 &nbsp; &nbsp; &nbsp; Consulte as Condições Gerais dessa
                    cobertura em
                    <a href="https://filoo.com.br/docs/Condicoes-Especiais-Cobertura-IPA.pdf"
                      target="_blank" rel="noopener noreferrer">
                      filoo.com.br/docs/Condicoes-Especiais-Cobertura-IPA.pdf</a>
                  </p>
                  <h3><strong>7&nbsp; &nbsp; Auxílio Funeral</strong></h3>
                  <p style="padding-left: 40px;">
                    7.1 &nbsp; &nbsp; &nbsp; Consulte as Condições Gerais dessa cobertura em
                    <a href="https://filoo.com.br/docs/Condicoes-Especiais-Auxilio-Funeral-Complementar.pdf"
                      target="_blank" rel="noopener noreferrer">
                      filoo.com.br/docs/Condicoes-Especiais-Auxilio-Funeral-Complementar.pdf
                    </a>
                  </p>
                  <h3><strong>8&nbsp; &nbsp; Sorteio Mensal</strong></h3>
                  <p style="padding-left: 40px;">
                    8.1 &nbsp; &nbsp; &nbsp; Consulte as Condições Gerais dessa
                    cobertura em
                    <a href="https://filoo.com.br/docs/Condicoes-Especiais-Sorteio-Mensal.pdf"
                      target="_blank" rel="noopener noreferrer">
                      filoo.com.br/docs/Condicoes-Especiais-Sorteio-Mensal.pdf
                    </a>
                  </p>
                  <h3><strong>9&nbsp; &nbsp; Einstein Conecta</strong></h3>
                  <p style="padding-left: 40px;">
                    9.1 &nbsp; &nbsp; &nbsp; O serviço de atendimento à
                    distância, disponível todos os dias, com suporte 24 horas, é
                    totalmente de responsabilidade da Einstein Conecta,
                    terceirizada da Filóo. Em caso de dúvidas, o Usuário poderá
                    consultar os Termos de Uso do Einstein Conecta.
                  </p>
                  <p style="padding-left: 40px;">
                    9.2 &nbsp; &nbsp; &nbsp; Após a contratação, o Einstein
                    Conecta tem um prazo de até 48 (quarenta e oito) horas para
                    a liberação do cadastro em seu banco de dados.
                  </p>
                  <p style="padding-left: 40px;">
                    9.3 &nbsp; &nbsp; &nbsp; Os atendimentos são realizados por
                    profissionais com conhecimento específico em suas áreas de
                    atuação, destinando-se à situações de
                    <strong><u>BAIXA COMPLEXIDADE</u></strong> como: (i)
                    Sintomas de gripe e resfriado; (ii) Febre; (iii) Dor de
                    cabeça; (iv) Desconforto Abdominal; (v) Náusea e vômito;
                    (vi) Dor de garganta e ouvido; (vii) Dor lombar; (viii)
                    Picadas; (ix) Dor ou infecção nos olhos; (x) Sintomas
                    urinários; (xi) Alergias e lesões; (xii) Dificuldade
                    respiratória; (xiii) Feridas e queimaduras.
                  </p>
                  <p style="padding-left: 40px;">
                    9.4 &nbsp; &nbsp; &nbsp; Eventual medicação, insumos, ou
                    qualquer contratação de serviços diversos de assistência à
                    saúde, que, porventura, sejam recomendados pelo Médico
                    atendente, para cuidado com a saude do Usuário, em
                    decorrência do atendimento por Teleorientação, serão de
                    exclusiva responsabilidade e custeio do Usuário.
                  </p>
                  <p style="padding-left: 40px;">
                    9.5 &nbsp; &nbsp; &nbsp; O Usuário está ciente que o tempo
                    de permanência mínima para os serviços contratados é de 6
                    (seis) meses. Em caso de cancelamento antecipado, o Usuário
                    arcará com o valor total dos 6 (seis) meses.
                  </p>
                  <p style="padding-left: 40px;">
                    9.6 &nbsp; &nbsp; &nbsp; Para mais informações sobre a
                    utilização do produto, acesse
                    <a href="https://telemedicina.einstein.br/termos.pdf"
                      target="_blank" rel="noopener noreferrer"><u>einstein.br/termos.pdf</u></a>
                  </p>
                  <h3>
                    <strong>10&nbsp; &nbsp; Condições de pagamento e cobrança</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    10.1 &nbsp; &nbsp; &nbsp; Todas as transações realizadas na
                    Plataforma Filóo ocorrem por meio de créditos inseridos no
                    Cartão Filóo, por isso só é possível agendar uma consulta ou
                    exame se o cartão tiver saldo disponível para tal.
                  </p>
                  <p style="padding-left: 40px;">
                    10.2 &nbsp; &nbsp; &nbsp; O Usuário concorda que, sendo a
                    Filóo licenciadora da Plataforma Filóo, compartilhará as
                    informações sobre os dados de cobrança do Usuário
                    exclusivamente com empresas operadoras de meios de
                    pagamento, nos termos da lei.
                  </p>
                  <p style="padding-left: 40px;">
                    10.3 &nbsp; &nbsp; &nbsp; Todos os recibos decorrentes dos
                    serviços prestados pelos Prestadores de Serviços de Saúde,
                    exames e medicamentos poderão ser solicitados diretamente
                    pelo Usuário ao prestador após a conclusão dos Serviços.
                  </p>
                  <p style="padding-left: 40px;">
                    10.4 &nbsp; &nbsp; &nbsp; &nbsp;Nos casos de contratação
                    direta dos Serviços da Filóo pelo Usuário, ou seja, quando o
                    Cartão Filóo não é corporativo e for solicitada a emissão, o
                    Usuário ficará responsável pelo pagamento, conforme disposto
                    no <strong>ANEXO I</strong>.
                  </p>
                  <p style="padding-left: 40px;">
                    10.5&nbsp; &nbsp; &nbsp; &nbsp; No caso de inadimplência
                    após 30 dias, benefícios indexados ao cartão Filóo serão
                    suspensos.
                  </p>
                  <p style="padding-left: 40px;">
                    10.6&nbsp; &nbsp; &nbsp; &nbsp; Caso ocorra atraso superior
                    a 90 dias, o serviço em sua totalidade será suspenso
                    automaticamente.
                  </p>
                  <p style="padding-left: 40px;">
                    10.7&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;O Usuário assumirá as
                    tarifas e taxas indicadas no
                    <strong>ANEXO II</strong> necessárias para viabilizar a
                    execução dos serviços.
                  </p>
                  <p style="padding-left: 40px;">
                    10.8&nbsp; &nbsp; &nbsp; Especificamente para o Plano Master
                    os serviços disponibilizados na Plataforma Filóo não possuem
                    prazo de fidelidade, podendo o Usuário realizar o seu
                    cancelamento a qualquer momento sem qualquer ônus.
                  </p>
                  <p style="padding-left: 40px;">
                    10.9&nbsp; &nbsp; Especificamente para o Plano Premium e
                    qualquer Plano que contemple Einstein Conecta os serviços
                    disponibilizados na Plataforma Filóo tem um prazo de
                    fidelidade mínimo de 6 (seis) meses. Após esse período, o
                    Usuário poderá realizar o cancelamento a qualquer momento,
                    sem qualquer ônus. A partir do sétimo mês, o usuário poderá
                    realizar o seu cancelamento a qualquer momento sem qualquer
                    ônus.
                  </p>
                  <h3>
                    <strong>11&nbsp; &nbsp; Conexão da Internet e equipamentos</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    11.1 &nbsp; &nbsp; &nbsp; O acesso à Internet é de
                    responsabilidade exclusiva do Usuário. Para garantir uma
                    consulta online de qualidade é recomendável uma conexão
                    estável e de banda larga. Caso o atendimento não possa ser
                    iniciado por problemas técnicos, o mesmo poderá ser
                    reagendado sem custo adicional para o Usuário. Caso o
                    atendimento seja interrompido por problemas técnicos, desde
                    que o Usuário comunique o ocorrido dentro do mesmo dia útil,
                    entraremos em contato com Usuário e o Prestador de Serviços
                    de Saúde para analisar o caso individualmente. Os serviços
                    prestados pela plataforma exigem o uso de um computador ou
                    smartphone conectado com uma Internet estável e de banda
                    larga (recomendamos uma conexão de pelo menos 2Mbs para o
                    atendimento), webcam, fone de ouvido e microfone para que o
                    Usuário e Prestador de Serviços de Saúde sejam protegidos
                    pelo sigilo necessário ao atendimento.
                  </p>
                  <h3>
                    <strong>12&nbsp; &nbsp; Cancelamento dos Serviços ou não comparecimento</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    12.1&nbsp; &nbsp; &nbsp; &nbsp; Após a confirmação de
                    disponibilidade pelo Prestador de Serviços de Saúde, o
                    Usuário terá 12 (doze) horas para cancelar a consulta. Caso
                    o Usuário não realize o cancelamento dentro deste período,
                    concorda que será considerado que aceitou a consulta.
                  </p>
                  <p style="padding-left: 40px;">
                    12.2&nbsp; &nbsp; &nbsp; &nbsp; Em caso de cancelamento de
                    uma consulta pelo Usuário em até 24 (vinte e quatro) horas
                    antes do horário agendado não haverá cobrança de Taxa de
                    Cancelamento. Porém, caso o Usuário cancele a consulta com
                    menos de 24 (vinte e quatro) horas antes do horário
                    agendado, haverá cobrança de Taxa de Cancelamento, conforme
                    <strong>ANEXO III.</strong>
                  </p>
                  <p style="padding-left: 40px;">
                    12.3&nbsp; &nbsp; &nbsp; &nbsp; Não comparecimento: Caso o
                    Usuário não compareça a consulta, será devido uma Taxa de
                    Cancelamento, conforme <strong>ANEXO III.</strong>
                  </p>
                  <h3><strong>13&nbsp; &nbsp; Prazo e Rescisão</strong></h3>
                  <p style="padding-left: 40px;">
                    13.1&nbsp; &nbsp; &nbsp; &nbsp; O presente instrumento e a
                    cobrança de tarifas vigorarão por indeterminado, podendo ser
                    suspensos ou interrompidos caso o Usuário se manifeste nesse
                    sentido.
                  </p>
                  <p style="padding-left: 40px;">
                    13.2&nbsp; &nbsp; &nbsp; &nbsp; O Usuário que contratou os
                    serviços da Filóo diretamente poderá cancelar os Serviços e
                    o Cartão Filóo a qualquer momento mediante solicitação por
                    escrito através do e-mail
                    <a href="mailto:comercial@filoo.com.br">comercial@filoo.com.br</a>.
                  </p>
                  <h3>
                    <strong>14.&nbsp; &nbsp; Limitação de responsabilidade</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    14.1&nbsp; &nbsp; &nbsp; &nbsp; O Usuário reconhece que a
                    Filóo é licenciadora da Plataforma Filóo. Suas obrigações e
                    responsabilidades estão limitadas as condições apresentadas
                    neste Termos de Uso.
                  </p>
                  <p style="padding-left: 40px;">
                    14.2&nbsp; &nbsp; &nbsp; &nbsp; A FILÓO NÃO É UMA EMPRESA
                    PRESTADORA DE SERVIÇOS MÉDICOS, EXAMES LABORATORIAIS,
                    ASSISTÊNCIA MÉDICA E/OU OPERA QUALQUER TIPO DE REEMBOLSO.
                    ASSIM, SEUS SERVIÇOS NÃO PRECISAM DE REGISTRO JUNTO À ANS -
                    AGÊNCIA NACIONAL DE SAÚDE SUPLEMENTAR. A FILÓO TAMBÉM NÃO
                    POSSUI NENHUMA RESPONSABILIDADE SOBRE A QUALIDADE,
                    PONTUALIDADE, ESTADO E EXISTÊNCIA DOS SERVIÇOS MÉDICOS, VEZ
                    QUE ESTES PROFISSIONAIS SÃO AUTONÔMOS E INDEPENDENTES DA
                    FILÓO.
                  </p>
                  <p style="padding-left: 40px;">
                    14.3&nbsp; &nbsp; &nbsp; &nbsp; A FILÓO NÃO É UMA EMPRESA DE
                    SEGUROS. ASSIM, SEUS SERVIÇOS NÃO PRECISAM DE REGISTRO JUNTO
                    À SUSEP – SUPERINTENDÊNCIA DE SEGUROS PRIVADOS. A FILÓO
                    APENAS INTERMEDIA A RELAÇÃO ENTRE A SEGURADORA E O USUÁRIO,
                    SENDO A SEGURADORA TOTALMENTE RESPONSÁVEL PELOS SERVIÇOS
                    OFERECIDOS.
                  </p>
                  <p style="padding-left: 40px;">
                    14.4&nbsp; &nbsp; &nbsp; &nbsp; A Filóo não possuirá nenhuma
                    responsabilidade em caso de falhas na execução de qualquer
                    serviço contratado através da Plataforma Filóo, assim como o
                    dever de indenizar o Usuário por quaisquer danos, diretos ou
                    indiretos, incidentais, especiais e emergentes, inclusive
                    lucros cessantes, perda de dados, danos morais ou
                    patrimoniais relacionados ou decorrentes do uso dos
                    Serviços. A responsabilidade das informações e atendimento
                    prestado pelos Prestadores de Serviços de Saúde são de sua
                    exclusiva responsabilidade.
                  </p>
                  <p style="padding-left: 40px;">
                    14.5&nbsp; &nbsp; &nbsp; &nbsp; A Filóo envidará seus
                    melhores esforços para oferecer uma plataforma segura,
                    estável e livre de erros ou vírus fazendo uso de todos os
                    meios cabíveis para aplicar os melhores métodos de proteção.
                    Não se responsabiliza, no entanto, por erros e vírus não
                    causados pela Plataforma Filóo e que podem decorrer de
                    utilizações indevidas dos Usuários.
                  </p>
                  <p style="padding-left: 40px;">
                    14.6&nbsp; &nbsp; &nbsp; &nbsp; A Filóo não será responsável
                    por quaisquer outros custos relacionados com a prestação de
                    Serviços ou aquisição de produtos contratados pelo Usuário
                    através da Plataforma Filóo, incluindo, mas não se limitando
                    a medicamentos, exames e/ou transporte.
                  </p>
                  <p style="padding-left: 40px;">
                    14.7&nbsp; &nbsp; &nbsp; &nbsp; Os Usuário reconhecem que as
                    atividades da Filóo são promovidas com intuito de viabilizar
                    o acesso aos Serviços de Saúde ou não, integrando usuários e
                    profissionais, através de meios tecnológicos, não havendo
                    vínculo de qualquer natureza com os profissionais que
                    prestam Serviços de Saúde ou parceiros terceirizados.
                  </p>
                  <h3>
                    <strong>15&nbsp; &nbsp; Propriedade Intelectual e Direitos de Imagem</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    15.1&nbsp; &nbsp; &nbsp; &nbsp; Todos os direitos à
                    Plataforma Filóo e sobre o conteúdo disponível nesta são de
                    titularidade da Filóo e, sua venda ou utilização para
                    quaisquer fins caracteriza infração aos direitos autorais,
                    de marca e/ou quaisquer outros direitos da Filóo.
                  </p>
                  <p style="padding-left: 40px;">
                    15.2&nbsp; &nbsp; &nbsp; &nbsp; A Filóo concede uma
                    autorização ao Usuário para uso limitado, não exclusivo, não
                    comercial, pessoal e intransferível, para visualizar,
                    imprimir, descarregar e armazenar os conteúdos contidos na
                    Plataforma Filóo. A Filóo poderá tomar todas as medidas
                    judiciais necessárias caso verifique o uso da Plataforma
                    Filóo fora desta autorização.
                  </p>
                  <h3>
                    <strong>16&nbsp; &nbsp; Alterações dos Termos de Uso</strong>
                  </h3>
                  <p style="padding-left: 40px;">
                    16.1&nbsp; &nbsp; &nbsp; &nbsp; A Filóo reserva-se ao
                    direito de alterar os Termos de Uso, bem como qualquer outra
                    política da Plataforma, a qualquer momento e ao seu
                    exclusivo critério. As alterações entrarão em vigor no
                    momento da respectiva publicação na Plataforma. O uso desta
                    depois da publicação constituirá aceitação de eventuais
                    alterações deste Termos de Uso. Se você não concordar com os
                    termos alterados, deverá descontinuar o uso da Plataforma.
                  </p>
                  <p style="padding-left: 40px;">
                    16.2&nbsp; &nbsp; &nbsp; &nbsp; No caso de alterações
                    significativas deste Termos de Uso ou da forma como a Filóo
                    usa suas informações, a Filóo promoverá esforços razoáveis
                    para dar publicidade a estas alterações, como uma mensagem
                    no Site ou no Aplicativo. A continuidade do uso da
                    ferramenta após tais modificações será considerado aceitação
                    das alterações realizadas.
                  </p>
                  <h3><strong>17&nbsp; &nbsp; Disposições Finais</strong></h3>
                  <p style="padding-left: 40px;">
                    17.1&nbsp; &nbsp; &nbsp; &nbsp; Em caso de qualquer
                    disposição deste Termos de Uso ser considerada inválida ou
                    ineficaz por qualquer órgão competente, não prejudicará as
                    demais que permanecerão em pleno vigor para todo e qualquer
                    efeito.
                  </p>
                  <p style="padding-left: 40px;">
                    17.2&nbsp; &nbsp; &nbsp; &nbsp; O Usuário responderá civil e
                    criminalmente por todas as informações que inserir na
                    Plataforma Filóo.
                  </p>
                  <p style="padding-left: 40px;">
                    17.3&nbsp; &nbsp; &nbsp; &nbsp; Eventual tolerância de
                    qualquer das partes será tida como ato de mera liberalidade,
                    não constituindo precedente, novação ou renúncia a direitos
                    que a legislação ou os Termos de Uso o assegurem.
                  </p>
                  <p style="padding-left: 40px;">
                    17.4&nbsp; &nbsp; &nbsp; &nbsp; Os presentes Termos de Uso
                    serão regidos pelas leis brasileiras. Fica eleito o foro da
                    Comarca da Capital do Estado de São Paulo como sendo o único
                    competente para dirimir quaisquer litígios e/ou demandas que
                    venham a envolver as partes.
                  </p>
                  <hr />
                  <h3 style="text-align: center;"><strong>ANEXO I</strong></h3>
                  Tabela mais descritivo de cobranças:
                  <table style="width: 100%; border: 1px solid #000;">
                    <tbody>
                      <tr>
                        <td colspan="2" width="595">
                          <p style="text-align: center;">
                            <strong>Tabela com Valores de Cobrança</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;" width="321">
                          <strong>Descrição</strong>
                        </td>
                        <td width="274">
                          <p style="text-align: center;">
                            <strong>Valor</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td width="321">
                          <p style="text-align: center;">
                            Valor padrão do Cartão Filóo do Plano Master
                          </p>
                        </td>
                        <td style="text-align: center;" width="274">
                          R$ 19,90 (dezenove reais e noventa centavos)
                        </td>
                      </tr>
                      <tr>
                        <td width="321">
                          <p style="text-align: center;">
                            Valor padrão do Cartão Filóo para dependente do
                            titular do Plano Master
                          </p>
                        </td>
                        <td width="274">
                          <p style="text-align: center;">
                            R$ 11,90 (onze reais e noventa centavos)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td width="321">
                          <p style="text-align: center;">
                            Valor padrão do Cartão Filóo do Plano Premium
                          </p>
                        </td>
                        <td style="text-align: center;" width="274">
                          R$ 39,90 (trinta e nove reais e noventa centavos)
                        </td>
                      </tr>
                      <tr>
                        <td width="321">
                          Valor padrão do Cartão Filóo para dependente do
                          titular do Plano Premium
                        </td>
                        <td width="274">
                          R$ 24,90 (vinte e quatro reais e noventa centavos)
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;" width="321">
                          Emissão de cartão físico para casos especiais:
                        </td>
                        <td width="274">
                          <p style="text-align: center;">
                            R$ 8,00 (oito reais)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;" width="321">
                          Custo de Postagem (Carta Registrada com AR):
                        </td>
                        <td width="274">
                          <p style="text-align: center;">
                            R$ 20,00 (vinte reais)
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p style="padding-left: 40px;">
                    (I) Valor do cartão individual: R$ 8,00 (oito reais) por
                    cartão físico disponibilizado ao Usuário em casos de
                    solicitação.
                  </p>
                  <p style="padding-left: 40px;">
                    (II) Custo de postagem via carta registrada com AR: R$ 20,00
                    (vinte reais). Cobrado em caso de solicitação de emissão e
                    envio do cartão físico.
                  </p>
                  <hr />
                  <h3 style="text-align: center;"><strong>ANEXO II</strong></h3>
                  <ol>
                    <li>Tabela de tarifas abaixo:</li>
                  </ol>
                  <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <p style="text-align: center;">
                            <strong>Tarifas de Recarga e Saque</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;">
                          <strong>Descrição</strong>
                        </td>
                        <td>
                          <p style="text-align: center;">
                            <strong>Valor</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="text-align: center;">Recarga</p>
                        </td>
                        <td style="text-align: center;">
                          R$ 3,00 (três reais)
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="text-align: center;">
                            Recarga com Cartão de Crédito
                          </p>
                        </td>
                        <td>
                          <p style="text-align: center;">
                            R$ 3,00 (três reais)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;">Tarifa de Saque</td>
                        <td>
                          <p style="text-align: center;">
                            R$ 6,00 (seis reais)
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr />
                  <h3 style="text-align: center;">
                    <strong>ANEXO III</strong>
                  </h3>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <p style="text-align: center;">
                            <strong>REGRAS DE CANCELAMENTO DE CONSULTA</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;">
                          <strong>Atividade</strong>
                        </td>
                        <td>
                          <p style="text-align: center;">
                            <strong>Usuário deverá:</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Cancelamento pelo usuário com antecedência maior do
                            que 24h do horário agendado</strong>
                        </td>
                        <td>
                          <p style="text-align: center;">R$ 0,00</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Cancelamento pelo usuário com antecedência menor do
                            que 24h do horário agendado</strong>
                        </td>
                        <td>
                          <p style="text-align: center;">
                            10% calculado sobre valor consulta
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Consulta realizada</strong></td>
                        <td>
                          <p style="text-align: center;">
                            100% do valor da consulta
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Falta do Usuário</strong></td>
                        <td>
                          <p style="text-align: center;">
                            10% do valor da consulta
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
export default {
    name: "filoo-term"
}
</script>

<style lang="sass">

</style>
